import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '@common/global';
import { SearchService } from '@services/search.service';
import { RecommendedService } from '@services/recommended.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-app-leftfilter',
  templateUrl: './app-leftfilter.component.html',
  styleUrls: ['./app-leftfilter.component.sass']
})
export class AppLeftfilterComponent implements OnInit {

  @Input('tab') tab: object;
  @Input('active') active: string;
  @Input('a') application: string;
  @Input('page') page: string;
  @Input('c') component: string;
  tabs: any = [];
  active_tab = "";
  dataLoding = true;
  response: any = [];
  total_record = 0;
  isLogin=false;
  recommended=false;
  filter = { "recent": "createdTime", "viewed": "views", "rated": "rating", "liked": "likes", "favorites": "favorites" };
  constructor(private _recommendedService: RecommendedService, private _searchService: SearchService, private _global: GlobalService) {
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }

   }

  ngOnInit(): void {
    this.tabs.push(this.tab);
    this.active_tab = this.active;
    this.loadFilterData();
  }
  returnZero() {
    return 0
  }
  loadData(key) {
    this.active_tab = key;
    this.loadFilterData();
  }
  recommend(){
    this.recommended=!this.recommended;
    if(this.recommended){
      this.loadFilterData();
    }
  }
  loadFilterData() {
    this.dataLoding = true;
    this.total_record = 0;
    this.response = [];
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      sortOrder: 'desc',
      sortString: this._global.getVal(this.filter, this.active_tab, ''),
      rows: 10
    };
    if (this.recommended) {
    p['sortString']= 'createdTime';
    this._recommendedService.application(p).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.response = data["response"]["docs"]; 
           this.total_record = this._global.getVal(data, 'response.numFound', '0');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    } else {
      
      this._searchService.application(p).subscribe(
        data => {
          this.dataLoding = false;
          if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
            this.response = data["response"]["docs"];
            this.total_record = this._global.getVal(data, 'response.numFound', '0');
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });

    }
  }
}
